import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setCaptchaSendModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import { IProps } from 'components/CaptchaSendModal/types';
import Modal from 'components/Modal';

const CaptchaSendModal: React.FC<IProps> = (props) => {
  const handleConfirm = () => {
    handleClose();
  };

  const handleClose = () => {
    props.setCaptchaSendModalVisible(false);
  };

  return (
    <>
      {props.modal.captchaSendModalVisible && (
        <Modal
          closeIcon
          visible={props.modal.captchaSendModalVisible}
          title="已發送驗證號碼"
          cancelButton={false}
          onConfirm={handleConfirm}
          onCancel={handleClose}
        >
          <p className="element__part">
            已傳送驗證號碼至手機號碼 <span>0983***123</span> 及電子信箱 <span>123***@gmail.com</span> 中
          </p>
        </Modal>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setCaptchaSendModalVisible: (visible: boolean) => dispatch(setCaptchaSendModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(CaptchaSendModal);
